import { ReactElement } from 'react';

export function Projects(): ReactElement {
  return (
    <>
      <div className="container">
        <h3>Funded Research Projects</h3>
        <ul className="project_ul">
          <li>
            More recent funded projects are avaiable at{' '}
            <a href="https://facultyprofiles.hkust.edu.hk/profiles.php?profile=shing-chi-cheung-sccheung#proj">
              here
            </a>
          </li>
          <li>
            Diagnosing Energy Inefficiencies in Mobile Applications based on
            Observable Sensory Data Utilization (611813)
          </li>
          <li>
            Fault Detection of Event-Driven Mobile Applications Using Static
            Analysis (611912) [事件驅動的移動應用程式錯誤之靜態檢測方法]
          </li>
          <li>
            Effective Regression Fault Detection for the Reuse of Spreadsheets
            (611811) [電子表格程序復用中錯誤的有效檢測]
          </li>
          <li>
            Detecting Adaptation Faults in Context-aware Pervasive Applications
            (612210) [普適計算中的適應性錯誤測試]
          </li>
          <li>
            Managing the Impact of Context Reduction on Pervasive Applications
            (612309) [普適計算中上下文適配對普適應用的影響及消除技術的研究]
          </li>
          <li>
            RFID Intelligent Dock Gate System: aGate Portal (SSRI08/09.EG01)
            [智能龙门架]
          </li>
          <li>
            RFID Benchmarking Methodology, Report and Tool Support
            (ITP/022/08LP) [射頻識別基準測試的關鍵技術之方法及應用]
          </li>
          <li>
            A study of Software Fault Localization and Coincidental Correctness
            (612108) [軟體錯誤定位和偶然正確性的研究]
          </li>
          <li>Performance Testing of RFID Embedded Systems (RPC07/08.EG24)</li>
          <li>
            Trustworthy RFID Technologies: Methodology and Practice
            (GHP/044/07LP)
          </li>
          <li>
            RFID Benchmarking: Methodology and Practice (ITP/022/07LP)
            [无线射频识别基准测试的关键技术之方法及应用]
          </li>
          <li>
            Context Management Support for Ubiquitous Computing (612306)
            [支援普適計算的上下文管理]
          </li>
          <li>服务计算的开放软件模型与协同机理研究 (NSFC 60736015)</li>
          <li>A Research Center for Ubiquitous Computing (HKBU 1/05C)</li>
          <li>
            An Extensible Fault-based Predicate Testing Toolset for Wireless
            Sensor Network Software Applications (ITS/076/06)
            [用於無線感知網絡應用軟件的可擴展性基於錯誤的謂詞測試工具集]
          </li>
          <li>
            Scalable IPTV and Interactive-movie Platforms for Ubiquitous
            Multimedia Streaming (GHP/045/05)
            [普適多媒體串流的可延伸網路電視(IPTV)與交互式電影(Interactive-movie)平台]
          </li>
          <li>
            Effective Deployment of Design Patterns for Software Extensibility
            (DAG05/06.EG40)
          </li>
          <li>
            Next Generation Online Multimedia Collaboration System (UIM/103) -
            Task 1 Investigator
          </li>
          <li>
            M-Services Collaboration and Integration (HKUST6167/04E)
            [移动服务的协作和整合]
          </li>
          <li>
            Fingerprinting Digital Entertainment Contents in Internet-Based
            Delivery (DAG03/04.EG27)
          </li>
          <li>Cross-Organizational Process Exceptions (HKUST6170/03E)</li>
          <li>
            Agent-Based Collaborative Workforce Management (CUHK 4190/03E)
          </li>
          <li>
            Fault-based Approaches to Specification-based Testing (CITYU
            1195/03E)
          </li>
          <li>
            Pattern Conformance Testing of Java Production Systems
            (HKUST6187/02E)
          </li>
          <li>
            Software for Advertising on Copyright Protected Music
            (SSRI01/02.BM01)
          </li>
          <li>
            TACCLE: Object-Oriented Software Testing at the Class and Cluster
            Levels (HKU 7033/99E)
          </li>
          <li>
            Digital Property Rights Infrastructure - Music and Publishing
            Industry Online Copyright Protection and Content Distribution
            (AF/168/99)
          </li>
          <li>
            Testing of distributed multimedia software systems (HKUST6159/98E)
          </li>
          <li>
            A Multimedia Architect's Assistant for Distributed Multimedia
            Applications (HKUST6088/97E)
          </li>
          <li>
            A Middleware for the Authoring of Distributed Multimedia
            Applications (SSRI96/97.EG08)
          </li>
          <li>
            Techniques and Support Tools for Analysing Distributed
            Object-Oriented Systems (JRS96/38)
          </li>
          <li>
            An Integrated Environment for Multimedia Applications on
            heterogeneous Networks (SSRC95/96.EG19)
          </li>
          <li>
            Automated testing and verification of distributed object-oriented
            software system (HKUST664/95E)
          </li>
          <li>
            Automated behaviour analysis technique for distributed finite-state
            systems (HKUST662/95E)
          </li>
          <li>
            Automated verification for distributed computing systems
            (DAG94/95.EG15)
          </li>
        </ul>
      </div>
    </>
  );
}
